import register from '../register';
import PlacesAutoComplete from './classes/address-autocomplete';

const b2bURL = window.b2b_signup_url;

class CheckAvailabilitySMB extends PlacesAutoComplete {

  constructor( opts ) {
    super( opts );
  }

  onSelect( address ) {
    const json    = JSON.stringify( address );
    const escaped = escape( json );
    const base64  = window.btoa( escaped );
    const enc     = window.encodeURIComponent( base64 );
    const url = `${ b2bURL }/${ enc }`;

    const addressVal = [
      address.name,
      ', ',
      address.city,
      ' ',
      address.state,
      ', ',
      address.postal_code
    ].join('');

    // Set value to leave it in input in case back button pressed
    this.input.value = addressVal;

    window.location = url;
  }
}

register( 'check-smb-availability', function() {
  const component = document.querySelector('.check-smb-availability-component');
  const input     = component.querySelector('#check-availability-input');
  const list      = component.querySelector('.results');

  new CheckAvailabilitySMB({ input, list });
});

export default undefined;


